<template lang="pug">
.wrapperr(v-if='ativarJanela')
    .bloco
        .bloco-head(@click='minimizarBloco = !minimizarBloco')
            h2 {{ $t('mensagens.diagnosticoSocioambiental.exportacao.titulo') }}
            i.mdi.bloco-icon.mdi-chevron-right(
                v-if='steps !== "download"',
                :class='[minimizarBloco ? "mdi-window-minimize" : "mdi-window-maximize"]'
            )
            i.mdi.bloco-icon.mdi-close(
                v-if='steps == "download"',
                @click='clear()'
            )
        transition(name='slide')
            .bloco-body(v-if='minimizarBloco')
                .bloco-lista(v-if='steps == "listagem"')
                    ul
                        li(
                            v-for='item in marcarExportarPDF',
                            :key='item.idLista'
                        )
                            span {{ item.nome }}
                            .i.mdi.mdi-trash-can-outline(
                                @click='excluirArquivo(item.idLista, item.nome)'
                            )

                    .bloco-footer
                        el-button(@click='handleCancelar()') {{ $t('mensagens.comuns.cancelar') }}
                        el-button(type='primary', @click='handleExportar') {{ $t('mensagens.diagnosticoSocioambiental.exportacao.exportar') }}

                .loading(v-if='steps == "carregamento"')
                    i.el-icon-loading
                    p {{ $t('mensagens.diagnosticoSocioambiental.exportacao.documentoCarregando') }}

                .download(v-if='steps == "download"')
                    p {{ $t('mensagens.diagnosticoSocioambiental.exportacao.documentoPronto') }}
                    el-button(
                        type='primary',
                        @click='handleDownload',
                        icon='el-icon-download'
                    ) {{ $t('mensagens.diagnosticoSocioambiental.exportacao.baixarDocumento') }}
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import store from '@/store';
import DiagnosticoSocioambientalService from '@/services/DiagnosticoSocioambientalService';
import { retryOperation } from '@/utils/retry-operation';
import { connect, subscribe, disconnect } from '@/utils/websocket';

export default {
    name: 'ExportarDocumento',
    data() {
        return {
            minimizarBloco: false,
            ativarJanela: false,
            steps: 'listagem',
            link: null
        };
    },

    computed: {
        ...mapGetters(['marcarExportarPDF', 'usuarioLogado'])
    },

    watch: {
        marcarExportarPDF: {
            handler: function () {
                if (this.marcarExportarPDF.length !== 0) {
                    this.ativarJanela = true;
                    this.minimizarBloco = true;
                }
            },
            immediate: true
        }
    },

    methods: {
        ...mapActions([
            'setMarcarExportar_PDF',
            'removeMarcarExportar_PDF',
            'clearMarcarExportar_PDF',
            'setEmProcessamento_PDF'
        ]),

        async excluirArquivo(id, nome) {
            const result = await this.$messageBox.confirm(
                this.$t(
                    'mensagens.diagnosticoSocioambiental.processamentoRemovido'
                ) + ` ${nome}?`,
                this.$t('mensagens.diagnosticoSocioambiental.exportacao.aviso'),
                {
                    confirmButtonText: this.$t('mensagens.comuns.sim'),
                    cancelButtonText: this.$t('mensagens.comuns.cancelar'),
                    type: 'warning'
                }
            );
            if (result) {
                this.removeMarcarExportar_PDF(id);
                if (this.marcarExportarPDF.length === 0) {
                    this.ativarJanela = false;
                }
            }
        },

        async handleCancelar() {
            const result = await this.$messageBox.confirm(
                this.$t(
                    'mensagens.diagnosticoSocioambiental.exportacao.desejaCancelarListaExportacao'
                ),
                this.$t('mensagens.diagnosticoSocioambiental.exportacao.aviso'),
                {
                    confirmButtonText: this.$t('mensagens.comuns.sim'),
                    cancelButtonText: this.$t('mensagens.comuns.cancelar'),
                    type: 'warning'
                }
            );
            if (result) {
                this.clear();
            }
        },

        clear() {
            this.clearMarcarExportar_PDF();
            this.ativarJanela = false;
            this.steps = 'listagem';
            this.link = null;
        },

        handleDownload() {
            if (this.link) {
                document.body.append(this.link);
                this.link.click();
                this.link.remove();

                this.clear();
            }
        },

        async handleExportar() {
            this.steps = 'carregamento';
            this.setEmProcessamento_PDF();
            let params = [];
            store.state.marcarExportarPDF.forEach(p => {
                params.push({
                    idTerritorio: p.idTerritorio,
                    tipoDocumento: p.tipoDocumento,
                    documento: p.documento,
                    camadas: p.camadas,
                    buffer: p.buffer,
                    nomeArquivo: p.nomeArquivo,
                    cars: p.cars
                });
            });

            try {
                await connect();
            } catch {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.diagnosticoSocioambiental.erro.naoFoiPossivelConectarApi'
                    )
                });
                return;
            }
            if (this.usuarioLogado) {
                try {
                    subscribe(
                        `${this.usuarioLogado.idKeyCloack}/exportar/pdf/diagnostico/socio`,
                        response => {
                            if (response) {
                                this.steps = 'download';
                                const linkSource = `data:application/pdf;base64,${response}`;
                                const link = document.createElement('a');
                                const fileName =
                                    'diagnosticos-socioambientais.pdf';

                                const currentDate = new Date();
                                const formattedDate = `${currentDate.getFullYear()}${String(
                                    currentDate.getMonth() + 1
                                ).padStart(2, '0')}${String(
                                    currentDate.getDate()
                                ).padStart(2, '0')}`;
                                const formattedTime = `${String(
                                    currentDate.getHours()
                                ).padStart(2, '0')}${String(
                                    currentDate.getMinutes()
                                ).padStart(2, '0')}${String(
                                    currentDate.getSeconds()
                                ).padStart(2, '0')}`;

                                const newFileName = fileName.replace(
                                    '.pdf',
                                    `-${formattedDate}-${formattedTime}.pdf`
                                );

                                link.href = linkSource;
                                link.download = newFileName;
                                this.link = link;
                            } else {
                                this.$notify.error({
                                    message: this.$t(
                                        'mensagens.diagnosticoSocioambiental.erro.naoFoiPossivelExportarPdf'
                                    )
                                });
                                this.clear();
                            }
                            disconnect();
                        }
                    );

                    retryOperation(
                        DiagnosticoSocioambientalService.exportarPdf,
                        params,
                        5000,
                        10
                    );
                } catch (error) {
                    this.$notify.error({
                        message: this.$t(
                            'mensagens.diagnosticoSocioambiental.erro.naoFoiPossivelExportarPdf'
                        )
                    });
                    disconnect();
                }
            } else {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.diagnosticoSocioambiental.erro.usuarioDeslogado'
                    )
                });
                disconnect();
            }
        }
    }
};
</script>
<style lang="scss">
.minimizar-enter-active,
.minimizar-leave-active {
    transition: opacity 0.5s ease;
}

.minimizar-enter-from,
.minimizar-leave-to {
    opacity: 0;
}
.wrapperr {
    position: fixed;
    bottom: 0;
    right: 0;
    z-index: 20000;
}

.bloco {
    position: absolute;
    right: 20px;
    bottom: 0px;
    background: var(--white);
    width: 300px;
    border-radius: 5px 5px 0px 0px;
}
.bloco-head {
    width: inherit;
    height: 45px;
    background: var(--primary);
    padding: 8px;
    border-radius: 5px 5px 0px 0px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
}
.bloco-head h2 {
    color: var(--white);
    display: inline-block;
    font-size: 14px;
}
.bloco-head .bloco-icon {
    color: var(--white);
    font-size: 24px;
    cursor: pointer;
}
.bloco-body {
    height: 216px;
    width: inherit;
    overflow: auto;
    margin-bottom: 53px;
}
.bloco-lista ul {
    list-style: none;
    margin: 0;
    padding: 9px;
}
.bloco-lista ul li {
    display: flex;
    justify-content: space-between;
    margin: 0;
    padding: 0;
    align-items: center;
    line-height: 17px;
    margin-bottom: 12px;
}
.bloco-lista ul li .mdi {
    font-size: 17px;
    color: #545454;
    cursor: pointer;
}
.bloco-lista ul li .mdi:hover {
    color: red;
}
.bloco-lista ul li span {
    font-size: 12px;
}
.bloco-footer {
    position: fixed;
    bottom: 0;
    display: flex;
    justify-content: space-between;
    width: 300px;
    padding: 0px 4px 4px 4px;
}

.slide-enter-active {
    -moz-transition-duration: 0.2s;
    -webkit-transition-duration: 0.2s;
    -o-transition-duration: 0.2s;
    transition-duration: 0.2s;
    -moz-transition-timing-function: linear;
    -webkit-transition-timing-function: linear;
    -o-transition-timing-function: linear;
    transition-timing-function: linear;
}

.slide-leave-active {
    -moz-transition-duration: 0.2s;
    -webkit-transition-duration: 0.2s;
    -o-transition-duration: 0.2s;
    transition-duration: 0.2s;
}

.slide-enter-to,
.slide-leave {
    max-height: 100px;
    overflow: hidden;
}

.slide-enter,
.slide-leave-to {
    overflow: hidden;
    max-height: 0;
}

.loading {
    i {
        font-size: 35px;
        margin-bottom: 20px;
    }

    padding: 30px 20px;
    text-align: center;
}

.download {
    padding: 80px 20px 0px;
    text-align: center;
}

.el-message-box__btns {
    button {
        width: 100px !important;
    }

    .el-button--primary {
        background-color: var(--primary);
        border-color: var(--primary);
        color: var(--white);
    }

    .el-button--primary:hover,
    .el-button--primary:focus {
        background-color: var(--secondary);
        border-color: var(--secondary);
        color: var(--color-button-hover);
        outline: 0px auto var(--secondary);
    }
}
</style>
